module.exports = __webpack_public_path__ + "img/Slide15.9832ce35.png";